import { date } from 'quasar'
import * as Enumerable from 'linq-es2015'
import CanonicalCodeAddEditModel from './canonicalcodeaddeditmodel-dialog-screen.vue';
import CanonicalCodeImportModel from './canonicalcodeimportmodel-dialog-screen.vue';
import CanonicalCodeListModel from './canonicalcodelistmodel-list-screen.vue';


export default {
    data: function () {
        return {
            screenKey: "CanonicalCodeListModel",
            loading: false,
            actionLocked: false,
            modelId: this.$route.params.id ?? 0, // Parent Model ID
            model: { },
            
            filter: null,
            columns: [
                {
                    name: 'Id',
                    label: 'Id',
                    align: 'left',
                    field: row => row.Id,
                    sortable: false,
                    style: '',
                    
                    isVisible: () => false
                },
                {
                    name: 'Code',
                    label: 'Code',
                    align: 'left',
                    field: row => row.Code,
                    sortable: true,
                    style: '',
                    
                    isVisible: () => true
                },
                {
                    name: 'CarrierName',
                    label: 'Carrier',
                    align: 'left',
                    field: row => row.CarrierName,
                    sortable: true,
                    style: '',
                    
                    isVisible: () => true
                },
                {
                    name: 'ServiceName',
                    label: 'Service',
                    align: 'left',
                    field: row => row.ServiceName,
                    sortable: true,
                    style: '',
                    
                    isVisible: () => true
                },
                {
                    name: 'IsActive',
                    label: 'Is Active',
                    align: 'left',
                    field: row => row.IsActive,
                    sortable: true,
                    style: '',
                    
                    isVisible: () => true
                },
                {
                    name: 'IsCustom',
                    label: 'Is Custom',
                    align: 'left',
                    field: row => row.IsCustom,
                    sortable: true,
                    style: '',
                    
                    isVisible: () => true
                },
                {
                    name: 'Actions',
                    label: 'Actions',
                    align: 'center',
                    field: row => row.Actions,
                    sortable: false,
                    style: '',
                    isVisible: () => true
                },

            ],
            columnsVisible: ['Code', 'CarrierName', 'ServiceName', 'IsActive', 'IsCustom', 'Actions'],
            dataSource: [],
            selected: [],
            editRowKey: null,
            pagination: {
                sortBy: 'Code',
                descending: false,
                page: 1,
                rowsPerPage: 10
            },
            applicationResources: null,
            toolTipStates: {},
            localTimezoneOffset: new Date().getTimezoneOffset()
        }
    },

    methods: {
        onClearFilterActionClick() {
            this.filter = null;
        },

        async refreshScreen() {
            this.modelId = this.$route.params.id ?? 0;
            this.selected = [];

            await this.onLoadListDataSource();
        },

        onCreateActionClick() {
            if (this.actionLocked) {
                return;
            }
            this.actionLocked = true;   
                
            this.$q.dialog({
                component: CanonicalCodeAddEditModel,
                parent: this,
                index: 0,
                modelId: 0,
                modelObject: null,
                actionLabel: 'Save',
                actionTitle: 'Create',
                editMode: true
            }).onOk((payload) => {
                this.dataSource.splice(0, 0, payload.model);
            }).onDismiss(() => {
                this.actionLocked = false;
            });
        },

        onEditActionClick(rowKey, rowIndex, row) {
            if (this.actionLocked) {
                return;
            }
            this.actionLocked = true;   
                
            this.$q.dialog({
                component: CanonicalCodeAddEditModel,
                parent: this,
                index: rowIndex,
                modelId: rowKey,
                modelObject: row,
                actionLabel: 'Save',
                actionTitle: 'Edit',
                editMode: true
            }).onOk((payload) => {
                var currentItemIndex = this.dataSource.map(e => { return e.Id; }).indexOf(rowKey);
                this.dataSource.splice(currentItemIndex, 1, payload.model);
            }).onDismiss(() => {
                this.actionLocked = false;
            });
        },

        onImportActionClick() {
            if (this.actionLocked) {
                return;
            }
            this.actionLocked = true;   
                
            this.$q.dialog({
                component: CanonicalCodeImportModel,
                parent: this,
                index: 0,
                modelId: 0,
                modelObject: null,
                actionLabel: 'Import',
                actionTitle: 'Import',
                editMode: true
            }).onOk((payload) => {
                this.refreshScreen();
            }).onDismiss(() => {
                this.actionLocked = false;
            });
        },

        onDeleteActionClick(rowKey, rowIndex, row) {
            if (this.actionLocked) {
                return;
            }
            this.actionLocked = true;
            
            this.$q.dialog({
                title: 'Confirm',
                message: 'Are you sure?',
                cancel: true,
                persistent: true
            }).onOk(() => {
                if (this.onDeleteModelDataSource(rowKey, row)) {
                    var currentItemIndex = this.dataSource.map(e => { return e.Id; }).indexOf(rowKey);
                this.dataSource.splice(currentItemIndex, 1);
                }
            }).onDismiss(() => {
                this.actionLocked = false;
            });
        },

        onExportActionClick() {
            if (this.actionLocked) {
                return;
            }
            try {
                this.actionLocked = true;   
                
                this.onCanonicalCodeExportServerActionDataSource({
                    id: this.modelId,
                params: null,
                filter: this.filter,
                localTimezoneOffset: this.localTimezoneOffset,
                selectedRowIds: this.selected.map(function(row){ return row.Id; }),
                dialogData: null,
                dialogFiles: null

                });
            }
            finally {
                this.actionLocked = false;
            }
        },

        async onLoadListDataSource() {
            try {
                this.loading = true;
                
                let response = await this.$http.get('/api/ui/canonical_codes/'.replace('{id}', this.modelId), {  });
                
                if (response.body.Metadata) {
                    this.model = response.body.Metadata;
                    
                    this.dataSource = response.body.Rows;
                } else {
                    this.dataSource = response.body;
                }
                
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },

        async onDeleteModelDataSource(id, params) {
            try {
                this.loading = true;

                let url = this.$prepareServerUrl('/api/ui/canonical_codes/{id}', id, params);
                let response = await this.$http.delete(url, {  });
                this.$processServerJsonResponse(response.body, this.refreshScreen);
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },

        async onCanonicalCodeExportServerActionDataSource(params) {
            try {
                this.$q.loading.show({
                    message: 'In progress...'
                });

                let requestBody = {
                    Filter: params.filter,
                    LocalTimezoneOffset: params.localTimezoneOffset,
                    SelectedRowIds: params.selectedRowIds,
                    DialogData: params.dialogData
                };
 
                // Request from list screen toolbar.
                let url = this.$prepareServerUrl('/api/ui/canonical_codes/export', params.id, params.params, null);
                let response = await this.$http.post(url, requestBody, { responseType: 'arraybuffer'
 });

                this.$processServerFileResponse(response);
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.$q.loading.hide();
            }
        },

        
        
    },

    computed: {
        screenTitle: function () {
            return 'Canonical Codes';
        },

        
    },

    watch: {
        // Reload data if the route changed manually from browser address bar
        $route: 'refreshScreen'
    },

    mounted: async function () {
        this.refreshScreen();

    }
}